<app-entity-edit-header
  [title]="'General Information'"
  [description]="'Enter the basics of your business'"
  [backUrl]="'/dashboard/pages'"
/>
<app-entity-edit-wrapper class="mobile:!pt-0">
  @if (entityEditComponent.modelLoading()) {
    <app-loader class="my-auto" />
  } @else {
    <div
      [formGroup]="generalForm()"
      class="flex flex-col gap-5 max-w-screen-lg grow"
    >
      <div>
        <app-avatar
          [mode]="'single'"
          [mimeType]="'image'"
          [subMimeTypes]="['jpeg', 'png', 'gif', 'webp', 'svg', 'bmp', 'avif']"
          [bucketName]="'avatar'"
          [formControl]="generalForm().controls.avatar"
          [label]="'Click to upload your cover photo'"
          class="mobile:-ml-6 mobile:-mr-6 mobile:w-screen mobile:!min-w-[100vw]"
          #avatar
        />
        <app-profile-photo-picker
          [formControl]="generalForm().controls.profilePhoto"
          htmlFor="profile-photo"
          class="-mt-8 mobile:-mt-6 ml-6 mobile:ml-0"
          #profilePhoto
        />
      </div>
      <div class="flex gap-6 mobile:flex-col small-tablet:flex-col">
        <app-input
          [label]="'Page name'"
          [formControl]="generalForm().controls.name"
          [errorMessage]="
            generalForm().controls.name.dirty ||
            generalForm().controls.name.touched ||
            forceShowErrors()
              ? generalForm().controls.name.errors?.['error']
              : null
          "
          [isRequired]="true"
          class="basis-1/2"
        />
        <div class="flex flex-col gap-1 text-start basis-1/2 w-full">
          <app-label
            [value]="'Username'"
            [required]="true"
            htmlFor="page-username"
          />
          <div class="flex focusable !p-0 overflow-hidden">
            <div
              class="font-mono flex items-center justify-center border-r-[1.5px] border-[var(--light)] px-3 text-sm text-gray-700 bg-gray-50"
            >
              koshery.com/
            </div>
            <input
              type="text"
              class="grow outline-none px-4 py-2"
              [size]="1"
              placeholder="Username"
              [formControl]="generalForm().controls.username"
              id="page-username"
            />
          </div>
          @if (usernameOutput()?.message) {
            <app-validation-output
              [value]="usernameOutput()?.message"
              [type]="usernameOutput()?.type"
            />
          }
        </div>
      </div>
      <div class="mobile:flex-col small-tablet:flex-col">
        <app-textarea
          [label]="'Description'"
          [formControl]="generalForm().controls.description"
          class="basis-full"
          [rows]="6"
          [placeholder]="'Describe your business in great detail'"
          [errorMessage]="
            generalForm().controls.description.dirty ||
            generalForm().controls.description.touched ||
            forceShowErrors()
              ? generalForm().controls.description.errors?.['error']
              : null
          "
          [maxLength]="600"
        />
      </div>
      <div class="flex gap-6 mobile:flex-col small-tablet:flex-col">
        <app-phone-input
          class="basis-1/2"
          [label]="'Business phone Number'"
          [isRequired]="true"
          [placeholder]="true"
          [formControl]="generalForm().controls.phoneNumber"
          [errorMessage]="
            generalForm().controls.phoneNumber.dirty ||
            generalForm().controls.phoneNumber.touched ||
            forceShowErrors()
              ? generalForm().controls.phoneNumber.errors?.['error']
              : null
          "
        />
        <app-input
          [label]="'Email'"
          [formControl]="generalForm().controls.email"
          [errorMessage]="
            generalForm().controls.email.dirty ||
            generalForm().controls.email.touched ||
            forceShowErrors()
              ? generalForm().controls.email.errors?.['error']
              : null
          "
          [type]="'email'"
          class="basis-1/2"
        />
      </div>
      <div class="flex gap-6 mobile:flex-col small-tablet:flex-col">
        <app-autocomplete
          [label]="'Address'"
          [formControl]="generalForm().controls.address"
          [loaderFunction]="loadAddresses"
          class="basis-1/2"
          #address
        />
        <app-input
          [label]="'Website or Koshery webpage'"
          [formControl]="generalForm().controls.website"
          [errorMessage]="
            generalForm().controls.website.dirty ||
            generalForm().controls.website.touched ||
            forceShowErrors()
              ? generalForm().controls.website.errors?.['error']
              : null
          "
          [isRequired]="false"
          class="basis-1/2"
          [type]="'url'"
        />
      </div>
      <div
        class="flex items-end mobile:items-stretch gap-6 flex-col mt-auto mb-0"
      >
        <app-button (click)="onNext($event)">Next</app-button>
      </div>
    </div>
  }
</app-entity-edit-wrapper>
